import React from 'react';
import {Body} from '@lightricks/react-design-system';
import gigProgress from './gigProgress';
import styles from './GigStatusLabel.module.scss';

interface GigStatusLabelProps {
  state: string;
  networkName: string | null;
}

function GigStatusLabel({state, networkName}: GigStatusLabelProps) {
  const {text} = gigProgress(state, networkName);

  return (
    <div className={styles.container} data-testid="gig-status-label">
      <Body size="md">{text}</Body>
    </div>
  );
}

export default GigStatusLabel;
